import { AccessibilityInfo } from "react-native";

import useTranslation from "$src/core/hooks/use-translation";
import useWatchlistAddMutation from "$src/core/mutations/use-watchlist-add-mutation";
import useWatchlistRemoveMutation from "$src/core/mutations/use-watchlist-remove-mutation";
import useWatchlistQuery from "$src/core/queries/use-watchlist-query";

const useWatchlist = () => {
  const { t } = useTranslation();
  const { data: watchlist } = useWatchlistQuery();

  const { mutateAsync: addToWatchlist } = useWatchlistAddMutation();
  const { mutateAsync: removeFromWatchlist } = useWatchlistRemoveMutation();

  const add = async (id: string) => {
    await addToWatchlist({ id });
    AccessibilityInfo.announceForAccessibility(t("WATCHLIST/ADDED"));
  };

  const remove = async (id: string) => {
    await removeFromWatchlist({ id });
    AccessibilityInfo.announceForAccessibility(t("WATCHLIST/REMOVED"));
  };

  const toggle = async (id: string) => {
    if (!watchlist) return;

    if (watchlist.items.some((i) => i.id === id)) {
      await remove(id);
    } else {
      await add(id);
    }
  };

  const isWatchlisted = (id: string) =>
    watchlist?.items.some((i) => i.id === id);

  return {
    watchlist,
    isWatchlisted,
    toggle,
  };
};

export default useWatchlist;
